import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editPosition } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import {
  EditPosition,
  EditPositionResponse,
} from "src/Pages/Company/OrganizationStructure/Positions/positions.models";

const useEditPosition = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    EditPositionResponse,
    Error,
    { positionId: string; formData: EditPosition }
  >({
    mutationFn: async ({ positionId, formData }) =>
      editPosition({
        companyId,
        structureId,
        positionId,
        formData,
      }),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zaktualizowano stanowisko"), "success");
      queryClient.invalidateQueries({
        queryKey: ["positions-list", companyId, structureId],
      });
    },
    onError: () => {
      dynamicNotification(
        __("Nie udało się zaktualizować stanowiska"),
        "error"
      );
    },
  });
};

export default useEditPosition;
